import templateUrl from './observation-field.html';

function frmObservationField() {
  return {
    restrict: 'A',
    scope: {
      model: '=',
      required: '&',
      patient: '='
    },
    templateUrl: templateUrl
  };
}

export default frmObservationField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/observation-field.directive.js
 **/